import React, { Component } from "react";
import { Button, Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import BlockUi from 'react-block-ui';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import * as bacLuongAction from './actions'
import * as bacLuongConstant from './constants'
import { storedb } from '../../views/client/storedb'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import NumberFormat from 'react-number-format';

class BacLuongEdit extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      item: {
        Ten: "",
        IsDeleted: -1,
        StoreId: dbContext.getStoreId(),
        LuongCoBan: 0
      },
      formError: {},
      formValid: false,
      storeId: dbContext.getStoreId(),
    };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleControlChange = (e) => {
    let { item } = this.state
    item[e.target.name] = e.target.value
    this.setState({ item })
  }
  handleSelectChange = (name, selectedOption) => {
    let { item } = this.state;
    switch (name) {
      case "TrangThai":
        item.IsActive = selectedOption.target.value
        break;
      default:
        break;
    }
    this.setState({ item })
  }
  handleMoneyChange = (name, data) => {
    let { item } = this.state;
    const value = data.floatValue;
    item[name] = value;
    this.setState({ item })
  }
  Cancel = () => {
    this.featchDetail();
  }
  featchDetail = () => {
    const { bacLuongDetailRequest } = this.props
    let bacLuongId = this.getParam("bacluong");
    var requestData = {
      BacLuongId: bacLuongId || 0
    }
    return bacLuongDetailRequest(requestData);
  }
  UpdateBacLuong = () => {
    let formError = {};
    let formValid = true;
    if (!this.state.item.Ten || this.state.item.Ten == "") {
      formError.Ten = 'Bạn chưa nhập tên bậc lương';
    }
    if (this.state.item.IsActive == -1) {
      formError.IsActive = 'Bạn chưa nhập trạng thái';
    }
    for (var prp in formError) {
      if (prp && formError[prp] != '') {
        formValid = false;
        break;
      }
    }
    this.setState({ formError, formValid });
    if (formValid) {
      let { item } = this.state
      this.props.bacLuongUpdateRequest(item);
    }
  }
  BackToListBacLuong = (item, e) => {
    this.props.history.push('/bacluong');
  }
  numberOnclick = (e) => {
    e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)
  }
  componentDidMount() {
    this.featchDetail();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.bacLuongEdit.type == bacLuongConstant.BACLUONG_DETAIL_SUCCESS) {
      let { item } = nextProps.bacLuongEdit;
      if (item.BacLuongId && item.BacLuongId > 0) {
        this.setState({
          item: item
        });
      }
    } else if (nextProps.bacLuongEdit.type == bacLuongConstant.BACLUONG_UPDATE_SUCCESS) {
      this.props.history.push("/bacluong");
    }
  }
  render() {
    const { formError, item } = this.state;
    const {
      bacLuongEdit: {
        isRequesting,
        errors,
        messages
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={false} >
          <Form>
            <FormGroup>
              <Label for="bacLuong">Tên bậc lương</Label>
              <Input type="text" name="Ten" id="bacLuong" placeholder="Bậc lương" value={item.Ten || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.Ten}</em>
            </FormGroup>
            <FormGroup>
              <Label for="bacLuong">Lương cơ bản</Label>
              <NumberFormat
                name={"LuongCoBan"}
                value={item.LuongCoBan}
                defaultValue={0}
                thousandSeparator={"."}
                decimalSeparator={","}
                type="tel"
                onClick={this.numberOnclick.bind(this)}
                onValueChange={this.handleMoneyChange.bind(this, "LuongCoBan")}
                className={"form-control order-input-price price"} />
              <em className="error invalid-feedback">{formError.LuongCoBan}</em>
            </FormGroup>
            <FormGroup>
              <Label for="statusSelect">Trạng thái</Label>
              <select name="IsDeleted" id="statusSelect" className="form-control" value={(item.IsActive && item.IsActive == true) ? 1 : 0} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                <option value={-1}>--Trạng thái--</option>
                <option value={1}>Hoạt động</option>
                <option value={0}>Ngừng hoạt động</option>
              </select>
              <em className="error invalid-feedback">{formError.IsActive}</em>
            </FormGroup>
          </Form>
          <div className="w-100 mb-2">
            <ButtonExt btnClass="mr-1"
              color="success"
              iconClass="fa-list"
              displayText="Danh sách"
              btnClick={() => this.BackToListBacLuong()}
              permission={""} />
            <ButtonExt btnClass="mr-1"
              color="primary"
              iconClass="fa-save"
              displayText="Lưu"
              btnClick={() => this.UpdateBacLuong()}
              permission={BtnPermissions.BacLuong.ADD_OR_UPDATE} />
          </div>
        </BlockUi>
        <Row>
          <Col md="12">
            {!isRequesting && !!errors.length && (
              <Errors errors={errors} />
            )}
            {!isRequesting && !!messages.length && (
              <Messages messages={messages} />
            )}
          </Col>
        </Row>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  bacLuongEdit: state.bacLuongEdit,
})
const connected = connect(mapStateToProps, {
  bacLuongDetailRequest: bacLuongAction.bacLuongDetailRequest,
  bacLuongUpdateRequest: bacLuongAction.bacLuongUpdateRequest,
  bacLuongListRequest: bacLuongAction.bacLuongListRequest,
})(BacLuongEdit)

const formed = reduxForm({
  form: 'bacLuongEdit',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/BacLuong/BacLuongEdit.js